import React, { Fragment } from 'react';

import { string, bool } from 'prop-types';

import { Backdrop, Container, LoadingProgress } from './styles';

const Loading = ({ isLoading, color, size, fullscreen, fullcontainer }) => (
  <Fragment>
    {isLoading && (
      <Fragment>
        {fullscreen && (
          <Backdrop open={isLoading}>
            <LoadingProgress propcolor={color} size={size} />
          </Backdrop>
        )}

        {!fullscreen && fullcontainer && (
          <Container>
            <LoadingProgress propcolor={color} size={size} />
          </Container>
        )}

        {!fullscreen && !fullcontainer && <LoadingProgress propcolor={color} size={size} />}
      </Fragment>
    )}
  </Fragment>
);

Loading.defultProps = {
  isLoading: false,
  color: null,
  size: '40px',
  fullscreen: false,
  fullcontainer: false,
};

Loading.propTypes = {
  isLoading: bool,
  color: string,
  size: string,
  fullscreen: bool,
  fullcontainer: bool,
};

export default Loading;
